import React, { Fragment } from "react";
import { Badge } from "reactstrap";
import moment from 'moment'

import DefaultOfferImg from "~/assets/images/default-offer.png";
import WheelImg from "~/assets/images/dailyGoals/wheel-of-fortune.png";
import CheckinImg from "~/assets/images/dailyGoals/check-in.png";

const BonusCard = ({item})=> {

  const formatDate = (date)=> moment(date).format("YYYY-MM-DD");

  const types = {
    1: { title : "Bonus"                     , icon : DefaultOfferImg},
    2: { title : "Checklist"                 , icon : DefaultOfferImg},
    3: { title : "Completed Profile"         , icon : DefaultOfferImg},
    4: { title : "Lottery Winner"            , icon : DefaultOfferImg},
    5: { title : "Telegram Profile"          , icon : DefaultOfferImg},
    6: { title : "Notification Subscriber"   , icon : DefaultOfferImg},
    7: { title : "7 Days Check-ins in a row" , icon : DefaultOfferImg},
    8: { title : "Spinning Wheel"            , icon : WheelImg},
    9: { title : "Check-in Bonus"            , icon : CheckinImg}
  }

  return (
    <Fragment>
      <img src={types[item.type].icon} />
      <div className="item-details">
        <div>
          <h6>  {types[item.type].title} </h6>
          <Badge color="points">  POINTS: {item.points} </Badge>
        </div>

        <div style={{textAlign: "right"}}>
          <h6>  {formatDate(item.claimedAt)} </h6>
          <Badge color="custom-completed"> COMPLETED </Badge>
        </div>
      </div>
    </Fragment>
  );
};

export default BonusCard;
